import cookie from 'react-cookies';
import env from '@/env';
import { TUserInfo } from '@/services/api/auth/get-user-info';

const COOKIE_DOMAIN = env.cookie.domain;
const COOKIE_ACCESS_TOKEN = 'atk';
const COOKIE_REFRESH_TOKEN = 'rfk';
const COOKIE_REFRESH_TOKEN_TIME = 'rfk_time';
const COOKIE_USER_INFO = 'user_info';
const cookieSetting = {
  path: '/',
  domain: COOKIE_DOMAIN,
};

const setCookie = (name: string, value: any, maxAge?: number): void => {
  cookie.save(name, value, {
    path: '/',
    domain: COOKIE_DOMAIN,
    maxAge: maxAge,
  });
};

const getCookie = (name: string): string => cookie.load(name);
const removeCookie = (name: string): void => cookie.remove(name, cookieSetting);

// updateUserFinalRole used to derive a 'Guest' role from the license status.
// Nothing ever called it and nothing read its result, while the screens checked
// for a 'Guest' role the backend never issues - its groups are Admin, Manager
// and Employee. Effective access now comes from `has_license`, which the API
// already reports as "holds a seat AND the company licence is usable".

class Helpers {
  getAccessToken = (): string => getCookie(COOKIE_ACCESS_TOKEN);

  storeAccessToken = (accessToken: string, expiredTime?: number): void =>
    setCookie(COOKIE_ACCESS_TOKEN, accessToken, expiredTime);

  getRefreshToken = (): string => getCookie(COOKIE_REFRESH_TOKEN);

  storeRefreshToken = (refreshToken: string, expiredTime?: number): void =>
    setCookie(COOKIE_REFRESH_TOKEN, refreshToken, expiredTime);

  getRefreshTokenTime = (): string => getCookie(COOKIE_REFRESH_TOKEN_TIME);

  storeRefreshTokenTime = (refreshTokenTime: string): void => setCookie(COOKIE_REFRESH_TOKEN_TIME, refreshTokenTime);

  clearTokens = (): void => {
    removeCookie(COOKIE_ACCESS_TOKEN);
    removeCookie(COOKIE_REFRESH_TOKEN);
  };

  getUserInfo = (): any => {
    const userInfo: any = getCookie(COOKIE_USER_INFO);
    return userInfo;
  };

  storeUserInfo = (userInfo: TUserInfo): void => {
    const userInfoString = JSON.stringify(userInfo);
    setCookie(COOKIE_USER_INFO, userInfoString);
  };

  // New function to remove user information
  removeUserInfo = (): void => {
    removeCookie(COOKIE_USER_INFO);
  };
}

const instance = new Helpers();
export default instance;
